seedWebApp.directive("googleChart", function ($window, $timeout) {
    return {
        restrict: "A",
        link: function (scope, elem, attr) {
            //console.log('googleCharts LINK' );
            var googleChart = null;
            var data = null;
            google.charts.setOnLoadCallback(createChart);

            function createChart() {
                //console.log('googleCharts createChart');
                if (attr.googleChart == 'Bar') {               
                    googleChart = new google.charts.Bar(elem[0]);
                }
                else if (attr.googleChart == 'Line') {
                    googleChart = new google.charts.Line(elem[0]);
                }
                else {
                    googleChart = new google.visualization[attr.googleChart](elem[0]);
                }

                //if (data) {
                //    console.log('draw waiting data');
                //    draw(data.dataTable, data.options)
                //}
                drawIfData();
            }

            function drawIfData() {
                if (data) {
                    //console.log('drawIfData OK');
                    //console.log(data.dataTable);
                    draw(data.dataTable, data.options)
                }
                //else {
                //    console.log('drawIfData -> NO DATA');
                //}
            }

            function draw(data, options) {                
                //console.log('googleCharts draw');
                if (googleChart) {
                    googleChart.draw(data, options);
                }
                //else {
                //    console.log('googleChart NOT READY');
                //}
            }

            function getOptions(options) {
                if (options) {
                    if (attr.googleChart == 'Bar' && google.charts.Bar) {
                        options = google.charts.Bar.convertOptions(options);
                    }
                }
                return options;
            }

            scope.$watch(attr.ngModel, function (newValue, oldValue) {
                //console.log('googleCharts WATCH');
                //console.log(newValue);
                data = newValue;
                //var dataTable = newValue.dataTable;
                //var options = getOptions(newValue.options);
                drawIfData();
                //draw(dataTable, options);
                //google.charts.setOnLoadCallback();                

                //JRM: GAMBI
                $timeout(function () {
                    //console.log('googleCharts TIMEOUT');
                    drawIfData();
                }, 2000);
                
            }, true);

            $window.onresize = function () {
                //$scope.overflowSize = $scope.AdjustSize();
                //ctrl.doResize();
                //console.log('googleCharts RESIZE');
                drawIfData();
            };


        }
    }
});